import styled from 'styled-components'

import { Row as NewRow, Section as NewSection, Col as NewCol, Heading as NewHeading } from '../../Parent/Registration/ParentRegistration.styles'

export const Row = NewRow;
export const Section = NewSection;
export const Col = NewCol;
export const Heading = NewHeading;

export const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: ${(props) => (props.width ? props.width : "100%")};
  color: #fff;
  margin-bottom: 6px;

  p {
    font: italic bold 15px "Roboto Condensed";
    margin-bottom: 0;
    text-transform: uppercase;

    a {
      color: #3ee9f7;
      text-decoration: underline;
      text-transform: initial;
      display: inline;
      font-size: 14px;
      font-weight: normal;
      margin-left: 4px;

      :hover {
        color: #acff24;
      }
    }
  }
  .date-picker {
    width: 100%;
  }
  .custom-textfield,
  .custom-datepicker, .custom-select {
    margin-top: 6px !important;
  }
`;


// WEBPACK FOOTER //
// ./src/pages/Onboard/Institution/Registration/SchoolRegistration.styles.tsx